<template>
  <div class="digital-upload-video-tc media-upload">
    <input class="media-upload-input" type="file" ref="mediaFile" @change="uploadMedia" :accept="accept" />
    <div class="media-upload-button" @click="addMedia">
      <slot></slot>
    </div>
    <CropDialog ref="crop" :cropImgUrl="cropImgUrl" @cropConfirm="cropConfirm"></CropDialog>
  </div>
</template>

<script>
import TcVod from 'vod-js-sdk-v6'
import { getUploadVideoSign } from '@api/video.js'
import CropDialog from '@components/editDrawer/edit/CropDialog.vue'
import { base64ToFile } from '@/utils'

export default {
  name: 'DigitalUploadVideoTc',
  data() {
    return {
      tcVod: '',
      cropImgUrl: ''
    }
  },
  props: {
    accept: {
      default: '*',
      mediaFile: null
    },
    // 最大值限制
    maxSize: {
      default: null,
      type: Number
    },
    // 最大存储空间限制
    maxSpace: {
      default: null,
      type: Number
    },
    // 最大值限制错误提示
    sizeTip: {
      default: null
    },
    // 类型不正确提示
    typeTip: {
      default: '请上传正确类型文件'
    },
    // 是否需要进行裁剪
    crop: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 获取签名
    getSignature() {
      return getUploadVideoSign().then((res) => {
        return res.data.data.signature
      })
    },
    // 添加媒体文件
    async addMedia() {
      const isLogin = await this.$store.dispatch('common/login')
      if (!isLogin) {
        return
      }
      if (this.$refs.mediaFile) {
        this.$refs.mediaFile.value = ''
      }
      this.$refs.mediaFile.click()
    },
    uploadMedia() {
      this.mediaFile = this.$refs.mediaFile.files[0]
      if (!this.mediaFile) {
        return
      }

      if (this.accept !== '*') {
        if (this.accept.indexOf(this.mediaFile.type) === -1) {
          this.$alert(this.typeTip, '提示', {
            confirmButtonText: '确定'
          })
          return
        }
      }

      if (this.maxSize) {
        if (this.mediaFile.size / 1048576 > Number(this.maxSize)) {
          this.$alert(this.sizeTip, '提示', {
            confirmButtonText: '确定'
          })
          return
        }
      }

      if (this.maxSpace) {
        if (this.mediaFile.size / 1048576 > Number(this.maxSpace)) {
          this.$emit('toSpace')
          return
        }
      }

      if (this.crop) {
        const imgFile = new FileReader()
        imgFile.readAsDataURL(this.mediaFile)
        imgFile.onload = (res) => {
          this.cropImgUrl = res.target.result
          this.$refs.crop.dialogVisible = true
          this.$nextTick(() => {
            this.$refs.crop.init()
          })
        }
      } else {
        this.upload()
      }
    },
    upload() {
      this.$emit('updateState', 'uploading')
      this.uploader = this.tcVod.upload({
        mediaFile: this.mediaFile, // 媒体文件（视频或音频或图片），类型为 File
        enableRaceRegion: false
      })

      this.uploader.on('media_progress', (info) => {
        this.$emit('updatePercentage', info.percent)
      })

      // 暂留 可以显示上传状态 如，上传中，上传完成
      // this.uploader.on('media_upload', (info) => {
      //   this.uploaderInfo.isVideoUploadSuccess = true
      // })

      let { size, type, name: title } = this.uploader.videoInfo
      this.uploaderInfo = {
        // isVideoUploadSuccess: false,
        // isVideoUploadCancel: false,
        size,
        type,
        title,
        coverUrl: '',
        creator: this.$store.state.common.userName
      }

      this.uploader
        .done()
        .then((doneResult) => {
          this.uploaderInfo.fileId = doneResult.fileId
          this.uploaderInfo.mediaUrl = doneResult.video.url
          this.$emit('uploadSuccess', this.uploaderInfo)
          this.$emit('updateState', 'done')
          if (this.$refs.mediaFile) {
            this.$refs.mediaFile.value = ''
          }
        })
        .catch((err) => {
          this.$emit('updateState', 'ready')
          this.$emit('uploadError', err)
          if (this.$refs.mediaFile) {
            this.$refs.mediaFile.value = ''
          }
        })
    },
    uploadCancel() {
      this.uploader.cancel()
      this.$emit('updateState', 'ready')
    },
    cropConfirm(file) {
      this.mediaFile = base64ToFile(file)
      this.upload()
    }
  },
  components: {
    CropDialog
  },
  mounted() {
    this.tcVod = new TcVod({
      getSignature: this.getSignature
    })
    this.$emit('updateState', 'ready')
  },
  destroyed() {
    if (this.uploader) {
      this.uploadCancel()
    }
  }
}
</script>
<style lang="scss" scoped>
.media-upload {
  width: 100%;
  height: 100%;
  position: relative;
  .media-upload-input {
    display: none;
  }
  .media-upload-button {
    cursor: pointer;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
